import { Component, OnInit, Input, Output, ViewChild, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

// 3rd party imports
import notify from 'devextreme/ui/notify';
import { DxPopupComponent } from 'devextreme-angular';

// Service imports
import { VendorAccountEditService } from '../../_services/vendor-account-edit.service';
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';

// Models import
import { VendorAccountParametersDto } from '../../_models/vendor-account-parameters-dto';
import { VendorNotesResultDto } from '../../_models/vendor-notes-result-dto';
import { SaveVendorAccountNotesParametersDto } from '../../_models/save-vendor-account-notes-parameters-dto';

@Component({
    selector: 'app-vendor-account-notes',
    templateUrl: './vendor-account-notes.component.html',
    styleUrls: ['./vendor-account-notes.component.scss']
})
export class VendorAccountNotesComponent implements OnInit, OnChanges {
    @ViewChild('notesPopup', { static: false }) notesPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() associationVendorId: number;
    @Input() vendorAccountId: number;
    @Input() accountNumber: number;
    @Input() hasNotes = false;

    @Output() vendorAccountNotesClose = new EventEmitter<boolean>();

    previousVendorAccountNotes: string;
    isNotesSaved = false;
    visible = false;

    constructor(
        private readonly vendorAccountEditService: VendorAccountEditService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.visible = false;
        setTimeout(() => this.show(), 100);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.communityId && changes.communityId.currentValue) {
            this.communityId = changes.communityId.currentValue;
            this.getVendorAccountNotes();
        }

        if (changes.associationVendorId && changes.associationVendorId.currentValue) {
            this.associationVendorId = changes.associationVendorId.currentValue;
            this.getVendorAccountNotes();
        }

        if (changes.vendorAccountId && changes.vendorAccountId.currentValue) {
            this.vendorAccountId = changes.vendorAccountId.currentValue;
            this.getVendorAccountNotes();
        }

        if (changes.accountNumber && changes.accountNumber.currentValue) {
            this.accountNumber = changes.accountNumber.currentValue;
        }
    }

    show(): void {
        this.visible = true;
    }

    onVendorAccountNotesPopupShown(): void {
        this.notesPopup.visible = true;
        this.notesPopup.instance.repaint();
    }

    onVendorAccountNotesPopClose(): void {
        this.notesPopup.visible = false;
        this.visible = false;
        this.reloadNotes();
    }

    onSaveVendorAccountNotes(newNote: string): void {
        this.saveVendorAccountNotes(newNote);
    }

    private getVendorAccountNotes(): void {
        if (this.communityId && this.associationVendorId && this.vendorAccountId) {
            this.getVendorAccountPreviousNotes();
        }
    }

    private getVendorAccountPreviousNotes(clearCache = false): void {
        const baseParams: VendorAccountParametersDto = new VendorAccountParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.associationVendorId = this.associationVendorId;
        baseParams.vendorAccountId = this.vendorAccountId;

        this.vendorAccountEditService.getVendorAccountNotes(baseParams).subscribe(
            (result: VendorNotesResultDto) => {
                this.previousVendorAccountNotes = result.note;
                if (clearCache) {
                    this.isNotesSaved = true;
                    this.notesPopup.instance.repaint();
                }
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private saveVendorAccountNotes(notes: string): void {
        const baseParams: SaveVendorAccountNotesParametersDto = new SaveVendorAccountNotesParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.associationVendorId = this.associationVendorId;
        baseParams.vendorAccountId = this.vendorAccountId;
        baseParams.newNote = notes;

        this.vendorAccountEditService.saveVendorAccountNotes(baseParams).subscribe(
            (result) => {
                notify('Notes saved successfully.', 'Success');
                this.getVendorAccountPreviousNotes(true);
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private reloadNotes(): void {
        if (this.isNotesSaved) {
            this.previousVendorAccountNotes = null;
            setTimeout(() => {
                this.isNotesSaved = false;
            }, 100);
        }
        this.vendorAccountNotesClose.emit(this.isNotesSaved);
    }

    public refreshVendorAccountNotes(): void {
        this.getVendorAccountPreviousNotes(true);
    }
}
